import { render, staticRenderFns } from "./OpenEmpty.vue?vue&type=template&id=c61bf082&scoped=true&"
import script from "./OpenEmpty.vue?vue&type=script&lang=js&"
export * from "./OpenEmpty.vue?vue&type=script&lang=js&"
import style0 from "./OpenEmpty.vue?vue&type=style&index=0&id=c61bf082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61bf082",
  null
  
)

export default component.exports